(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zunada-product-story"] && !Shopify.designMode) return;
  try {
    
function initZunadaGrowth() {
  const buy = document.querySelector('.zunada-growth-page #ZunadaBuy');
  const sticky = document.querySelector('.z-growth-sticky');
  if (!buy || !sticky || sticky.dataset.observing) return;
  sticky.dataset.observing = 'true';
  const observer = new IntersectionObserver(([entry]) => {
    sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
  }, { threshold: 0 });
  observer.observe(buy);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initZunadaGrowth);
else initZunadaGrowth();
document.addEventListener('shopify:section:load', initZunadaGrowth);

  } catch(e) { console.error(e); }
})();
})();
